import { preparePhone } from './phone';
import { IRegion, IRequestFormValues } from '../../../types/requestForm';

export const prepareTrackingParams = (values: IRequestFormValues) => {
  return {
    phone: preparePhone(values.phone),
    regionId: (values.region as IRegion).id,
    regionName: (values.region as IRegion).label,
    searchWishes: values.requirements.trim() || undefined,
  };
};
